<template>
    <component :is="component" :filterData="filterData" :sortData="sortData" :paginationData="paginationData"
               v-if="component"/>
</template>

<script>
export default {
    name: "CompetitionFilterLink",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        filterLayout: {type: String,default: () => ''},
        filterData: {type: Object,default: () => {}},
        sortData: {type: Object, default: () => {}},
        paginationData: {
            type: Object,
            default: () => {return {total: 0, page: 0, size: 0,}}
        },
    },
    data() {
        return {
            component: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {

    },
    mounted() {
        this.filterLoader();
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        loader() {
            if (!this.filterLayout) {
                return null
            }
            return () => import(`@/template/competition/filter/${this.filterLayout}`)
        },
    },
    methods: {
        filterLoader() {
            this.loader()
                .then(() => {
                    this.component = () => this.loader()
                })
                .catch(() => {
                    this.component = () => import('@/template/competition/filter/CompetitionFilterDefaultLayout')
                })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
